// Version : 1.0.0
// Author : AGALYA

const PassbookChequeDetailsActionType = {
	/** ***************** PassbookCheque Update Start ************************/
	UPDATE_PASSBOOK_CHEQUE_START: 'update_passbook_cheque_start',
	UPDATE_PASSBOOK_CHEQUE_SUCCESS: 'update_passbook_cheque_success',
	UPDATE_PASSBOOK_CHEQUE_FAILURE: 'update_passbook_cheque_failure',
	UPDATE_PASSBOOK_CHEQUE_RESPONSE_REST_START: 'update_passbook_cheque_response_reset_start',
	UPDATE_PASSBOOK_CHEQUE_RESPONSE_CHANGED: 'update_passbook_cheque_response_changed',
	/** ***************** PassbookCheque Update End ************************/
};

export default PassbookChequeDetailsActionType;
